import { SafePipeElements } from './../safePipe.pipe';
import { ScreenElementClass } from './../screen-element.class';
import { ICustomPropConfig } from './../../prop-editors.moudule/custom-prop-config.interface';
import { DomSanitizer } from '@angular/platform-browser';
import { SeVideoYoutubeConfig } from './se-video-youtube-config.class';
import { Observer } from 'rxjs/Observer';
import { IScreenElement } from './../screen-element.interface';


import {
  Component, OnInit, AfterViewInit, OnDestroy, ViewChild, Injector, ElementRef, ChangeDetectorRef, SimpleChange, Renderer2
} from '@angular/core';
import { VgAPI } from 'videogular2/core';


@Component({
  selector: 'app-se-video',
  templateUrl: './se-video-youtube.component.html',
  styleUrls: ['./se-video-youtube.component.css'],
  providers: [ ],
})
export class SeVideoYoutubeComponent extends ScreenElementClass implements IScreenElement, OnInit, OnDestroy, AfterViewInit {
  public sizeChangeObserver: Observer<{ size: { width: number, height: number } }> = {
    next: (x) => {

    },
    error: (err) => {

    },
    complete: () => {

    }
  };

  public elementConfig = new SeVideoYoutubeConfig(); // override value of base config;

  constructor(
    public injector: Injector,
    public sanitizer: DomSanitizer,
    public elementRef: ElementRef,
    public changeDetectorRef: ChangeDetectorRef,
    public renderer: Renderer2
  ) {
    super(sanitizer); // initilize base class
    this.elementConfig = new SeVideoYoutubeConfig(); // create new config for this element type

    // get inital configs (if passed by injector)
    const startingElementConfig = this.injector.get('elementConfig');  // get commonConfig Value if injected
    if (startingElementConfig) {
      this.elementConfig.fromJson(startingElementConfig);
    }
  }

  ngOnInit() {

    this.elementConfig.isYoutubeVideo = true;
    this.elementConfig.youtubeId = '3tmd-ClpJxA'; // taylor swift test video
  }

  ngAfterViewInit() {
    this.onElementReadySubject.next(this);
  }

  ngOnDestroy() {
  }

  changeHook(change: SimpleChange) {

  }


  getCustomProperties() {

    const userAdjustableProps: ICustomPropConfig[] = new Array;

    const backgroundColor: ICustomPropConfig = {
      type: 'pe-colorpicker',
      name: 'Background Color',
      propPath: 'elementConfig.backgroundColor',
      defaultValue: null,
      tooltip: 'The default color behind the video',
      showDefaultReset: true,
      groupName: null,
      settings: {
      }
    };

    return userAdjustableProps;
  }



}






// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/designer.module/screen-elements.module/se-video-youtube/se-video-youtube.component.ts